import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { ImBlog } from "react-icons/im";
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <svg  className="img-fluid logo" alt="brand" width="54" height="30" viewBox="0 0 54 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.68 0.599998H16.28L26.72 29H21.04L18.4 21.92H8.48L5.88 29H0.2L10.68 0.599998ZM17.4 18.04L13.48 6.32L9.4 18.04H17.4ZM36.7225 29.4C34.9358 29.4 33.2292 29.1067 31.6025 28.52C29.9758 27.9333 28.5758 27.0667 27.4025 25.92L29.3225 22.44C30.5758 23.4533 31.8025 24.2 33.0025 24.68C34.2292 25.16 35.4025 25.4 36.5225 25.4C37.5625 25.4 38.3892 25.2133 39.0025 24.84C39.6425 24.4667 39.9625 23.9067 39.9625 23.16C39.9625 22.6533 39.7892 22.2667 39.4425 22C39.0958 21.7067 38.5892 21.4533 37.9225 21.24C37.2825 21.0267 36.4958 20.7867 35.5625 20.52C34.0158 20.0133 32.7225 19.52 31.6825 19.04C30.6425 18.56 29.8558 17.96 29.3225 17.24C28.8158 16.4933 28.5625 15.5467 28.5625 14.4C28.5625 13.0133 28.9092 11.8267 29.6025 10.84C30.3225 9.82667 31.3092 9.04 32.5625 8.48C33.8425 7.92 35.3358 7.64 37.0425 7.64C38.5358 7.64 39.9492 7.88 41.2825 8.36C42.6158 8.81333 43.8292 9.56 44.9225 10.6L42.7625 14C41.6958 13.1733 40.6825 12.5733 39.7225 12.2C38.7625 11.8 37.7892 11.6 36.8025 11.6C36.2425 11.6 35.7092 11.6667 35.2025 11.8C34.7225 11.9333 34.3225 12.16 34.0025 12.48C33.7092 12.7733 33.5625 13.2 33.5625 13.76C33.5625 14.2667 33.6958 14.6667 33.9625 14.96C34.2558 15.2267 34.6825 15.4667 35.2425 15.68C35.8292 15.8933 36.5358 16.1333 37.3625 16.4C39.0425 16.88 40.4558 17.3733 41.6025 17.88C42.7758 18.3867 43.6558 19.0133 44.2425 19.76C44.8292 20.48 45.1225 21.48 45.1225 22.76C45.1225 24.84 44.3625 26.4667 42.8425 27.64C41.3225 28.8133 39.2825 29.4 36.7225 29.4ZM48.6481 29V23.24H53.0481V29H48.6481Z" fill="#CD5FF8"/>
          </svg>

        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/about"
                onClick={() => updateExpanded(false)}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/project"
                onClick={() => updateExpanded(false)}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />{" "}
                Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/resume"
                onClick={() => updateExpanded(false)}
              >
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="d-none">
              <Nav.Link
                href="https://soumyajitblogs.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <ImBlog style={{ marginBottom: "2px" }} /> Blogs
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="fork-btn">
              <Button
                href="https://github.com/helloakshay27/"
                target="_blank"
                className="fork-btn-inner"
              >
                <CgGitFork style={{ fontSize: "1.2em" }} />{" "}
                <AiFillStar style={{ fontSize: "1.1em" }} />
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
